// @ts-nocheck
import React from 'react';
import { ArrowRight } from 'lucide-react';

import { NamedLink } from '../../../components';

interface CTASectionProps {
  sectionId: string;
  sectionData?: any[];
  [key: string]: any;
}

const CTASection: React.FC<CTASectionProps> = ({ sectionId, sectionData, ...extraProps }) => {
  return (
    <section id={sectionId} className="bg-primary text-white">
      <div className="container px-4 md:px-6 py-16 lg:py-20">
        <div className="max-w-3xl mx-auto text-center space-y-6">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold">
            Ready to Simplify Your Schedule?
          </h2>
          <p className="text-white/80 text-lg font-medium">
            Join parents who have discovered a better way to
            find and schedule kids activities.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <NamedLink name="SignupPage">
              <span className="servibe-btn inline-flex items-center gap-2 px-8 py-3.5 text-base bg-accent text-foreground font-semibold rounded-full overflow-hidden relative after:absolute after:inset-0 after:left-0 after:w-0 after:rounded-full after:bg-white after:transition-all after:duration-500 hover:after:w-full" data-testid="button-get-started">
                <span className="relative z-10 flex items-center gap-2">
                  Get Started Free
                  <ArrowRight className="h-4 w-4" />
                </span>
              </span>
            </NamedLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
